import { InputIcon } from '@platform/ui-library';
import { FC, SyntheticEvent } from 'react';
import { FormField } from '@app/form_components';
import { UseObjectFormObject, useObjectForm } from '@app/hooks';
import { HumanAssistedResolutionObjectConfig } from '@app/types';
import { NodeFooter } from './NodeFooter';
import { NodeHeader } from './NodeHeader';

export type HumanAssistedResolutionNodeModelFormProps = {
  object: UseObjectFormObject<HumanAssistedResolutionObjectConfig>;
};

export const HumanAssistedResolutionNodeModelForm: FC<HumanAssistedResolutionNodeModelFormProps> = ({
  object
}) => {
  const { createSubmitHandler, getControlProps } = useObjectForm({ object });
  const { error: timeoutError, ...timeoutField } = getControlProps('noActivityTimeout');

  return (
    <form key="form" className="flex-column flex-gap" onSubmit={createSubmitHandler()}>
      <NodeHeader getControlProps={getControlProps} />
      <FormField
        error={timeoutError}
        label="No Activity Timeout"
        tooltip="Seconds to wait with no activity before this node times out."
      >
        <InputIcon
          {...timeoutField}
          onChange={(event: SyntheticEvent<HTMLInputElement>) => {
            timeoutField.onChange(event.currentTarget.value);
          }}
          placeholder="Seconds to wait with no activity before timing out"
          value={timeoutField.value ?? ''}
        />
      </FormField>
      <NodeFooter getControlProps={getControlProps} />
    </form>
  );
};
